import React from "react";
import "./SocialSustainability.css";
import Footer from "./Footer";
import socimg1 from "../assets/soc-img1.png";


function SocialSustainability() {
    const cards = [
        {
            title: "Human Rights",
            icon: "🛡️",
            desc: "Protecting dignity, ensuring well-being.",
            points: [
                <><b>100%</b> employee training & awareness on human rights</>,
                <><b>100%</b> annual health check-up coverage for employees</>,
                <>SCL Wellness <b>360"</b> for ongoing physical and mental health support</>,
            ],
        },
        {
            title: "Diversity & Inclusion",
            icon: "🌍",
            desc: "Equal opportunity. Respect. Representation.",
            points: [
                <><b>100% DEI</b> sensitization for all employees</>,
                "Progressive gender diversification plan across all functions",
                "Inclusion of Persons with Disabilities (PwD)",
            ],
           
        },
        {
            title: "Workplace Ergonomics",
            icon: "🪑",
            desc: "Designing healthy, fatigue-free, and safe work environments.",
            points: [
                <><b>100% REBA & RULA</b> ergonomic assessments across identified roles</>,
                <><b>100%</b> employee training on ergonomics awareness</>,
                "Deployment of ergonomics assessment software",
                "Workplace redesign initiatives to reduce strain and enhance comfort",
            ],
        },
        {
            title: "Health & Well-Being",
            icon: "❤️",
            desc: "Supporting holistic health—physical, mental, and emotional.",
            points: [
                "Regular programmes on yoga, mental well-being and lifestyle diseases",
                <><b>1000+</b> employee and worker health check-ups annually</>,
                <><b>500+</b> employees covered under Wellness 360 programmes</>,
                <><b>500+</b> contract workers provided extended health checks</>,
                <>Mental health support through partnership with <b>YourDOST</b></>,
                <><b>“Eat Right Campus 2023”</b> certification</>,
                "Stepathon and wellness challenges to promote active living",
            ],
        },
        {
            title: "Health & Safety",
            icon: "⛑️",
            desc: "Zero harm mindset. Culture transformation. Digital safety.",
            points: [
             
                "Digital safety integration across critical operations",
                <>Safety culture transformation in partnership with <b>DSS+</b></>,
                "Behaviour-based safety programmes, capability building and recognition",
                "AI-based PPE compliance monitoring",
                "AI integration on high-risk machines",
                "Comprehensive ergonomic risk assessments",
            ],
        },
        {
            title: "360-Degree Safety Approach",
            icon: "🔄",
            desc: "Protecting employees, suppliers, families & communities.",
            sections: [
                {
                    subTitle: "Road Safety",
                    points: [
                        "Gamified defensive driver training",
                        "Road safety programs for employees, children & families",
                    ],
                },
                {
                    subTitle: "Supplier Safety",
                    points: [
                        "Compliance support and coaching for suppliers",
                        "Safety scorecards, training & reward programs",
                    ],
                },
            ],
        },
    ];

    return (
        <section id="soc">
            <section className="env-section">
                {/* ---------- INTRO SECTION ---------- */}
                <div className="env-light-wrapper">
                    <div className="prod-light-text">
                        <h3>Social Sustainability at SCL</h3>

                        <p>
                            <b>
                                Building a Safe, Inclusive, Respectful and Empowered Workplace
                            </b>
                        </p>

                        <p style={{ marginTop: "10px" }}>
                            Social sustainability is a core pillar of Sundaram Clayton Limited
                            (SCL). Our people are the heartbeat of our leadership and the
                            catalyst for our innovation. We place their health and safety above
                            all else, invest in well-being, champion inclusivity, and create
                            pathways for continuous growth.
                        </p>
                    </div>

                    <div className="lightweighting-image" >
                        <img src={socimg1} alt="Dr. RaviKiran S Avvaru" />
                    </div>
                </div>

                {/* ---------- CARDS GRID ---------- */}
                <div className="ps-grid">
                    {cards.map((card, index) => (
                        <div className="ps-card" key={index}>
                            <div className="ps-header">
                                <span className="ps-icon">{card.icon}</span>
                                <h3>{card.title}</h3>
                            </div>

                            <p className="ps-desc"><b>{card.desc}</b></p>

                            {/* Normal bullet points */}
                            {card.points && (
                                <ul>
                                    {card.points.map((point, i) => (
                                        <li key={i}>{point}</li>
                                    ))}
                                </ul>
                            )}

                            {/* Sectioned bullet points (Road / Supplier Safety) */}
                            {card.sections &&
                                card.sections.map((section, si) => (
                                    <div className="ps-section" key={si}>
                                        <h4 className="ps-subtitle">{section.subTitle}</h4>
                                        <ul>
                                            {section.points.map((pt, pi) => (
                                                <li key={pi}>{pt}</li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}

                            {/* Highlight box */}
                            {card.highlightBox && (
                                <div className="ps-highlight">{card.highlightBox}</div>
                            )}

                            {/* Tags */}
                            {card.tags && (
                                <div className="ps-tags">
                                    {card.tags.map((tag, i) => (
                                        <span key={i}>{tag}</span>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* ---------- APPROACH ---------- */}
                <p style={{ textAlign: "center", margin: "40px 250px 60px 250px" }}>
                    Together, these initiatives reflect SCL’s commitment to building a workplace that is not only productive, but safe, inclusive and sustainable for every stakeholder.
                </p>
            </section>

            <Footer />
        </section>
    );
}

export default SocialSustainability;
